import { render, staticRenderFns } from "./LoginEmail.vue?vue&type=template&id=60a12177&scoped=true"
import script from "./LoginEmail.vue?vue&type=script&lang=js"
export * from "./LoginEmail.vue?vue&type=script&lang=js"
import style0 from "./LoginEmail.vue?vue&type=style&index=0&id=60a12177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a12177",
  null
  
)

export default component.exports